import { Injectable } from '@angular/core';
import { DEFAULT_PROJECT_SHELL_NAMES } from '@wms/app/core';
import { WmHttpService } from "@wms/app/services";

@Injectable({
  providedIn: 'root'
})
export class ProjectShellService {
  TARGET: string;
  projectShells: any;
  loadedProjectShellsCount: any;

  constructor(private wmHttpService: WmHttpService) {
    this.TARGET = "ProjectShell";
  }
  /**
* @ngdoc function
* @name wm.projectShell.$ProjectShellManager#loadProjectShells
* @methodOf wm.projectShell.$ProjectShellManager
* @function
*
* @description
* load all the projectShells
*
*/
  loadProjectShells() {
    this.getProjectShellList();
  }

  getProjectShellList() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'list'
    }) as Promise<any>).then((projectShellsList) => {
      let sortedProjectShellList, loadedProjectShellsCount = 0,
        projectShellsCount = Object.keys(projectShellsList).length,
        defaultProjectShellNames = DEFAULT_PROJECT_SHELL_NAMES;

      this.projectShells = [{
        "name": defaultProjectShellNames.DEFAULT,
        "id": "",
        "removable": false
      }];

      sortedProjectShellList = projectShellsList.sort((projectShell1: any, projectShell2: any) => {
        return projectShell1.createdDate - projectShell2.createdDate;
      });

      /*fetch the configuration of the themes in asynchronous way and trigger the callback function*/
      sortedProjectShellList.forEach((projectShell: any) => {
        this.onLoadProjectShellConfig(projectShell);
      });

    });
  }

  onLoadProjectShellConfig(projectShell: any) {

    /*TODO ask for projectShell-image url*/
    let items: any = {
      "id": projectShell.id,
      "name": projectShell.name,
      "versionId": projectShell.versionId
    };

    items.removable = !projectShell.system;

    this.projectShells.push(items);

    /*Increment the counter after load*/
    this.loadedProjectShellsCount += 1;
    /*Reset the counters after all the projectShells have been loaded*/
    // TODO - needed?
    // if (this.loadedProjectShellsCount === projectShellsCount) {
    //     $rootScope.$safeApply($scope);
    // }
  }

  removeProjectShell(params: any) {
    return new Promise((res, rej) => {
      this.remove(params).then(() => {
        this.loadProjectShells();
        res('');
      }).catch(() => {
        rej();
      });
    })

  }

  remove(params: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'remove',
      pathParams: {
        projectShellID: params.projectShellID,
        versionId: params.versionId
      }
    }) as Promise<any>);
  }
}